<template>
<div class="template-wrapper" :style="getScale">
   <div class="template" id="canvas_template" :style="instanceJson.tmpl.view">

      <!-- Background Image -->
      <asset-zone 
         :zone="zone1"
         :currScene="currScene"
         :hidden="isHiddenZone(zone1)"
         :scale="scale"
         @click.native="handleZoneClicked(zone1)"
         @removeAsset="handleRemoveAsset(zone1)">
      </asset-zone>

      <!-- Home Logo -->
      <asset-zone 
         :zone="zone2"
         :currScene="currScene"
         :hidden="isHiddenZone(zone2)"
         :scale="scale"
         @click.native="handleZoneClicked(zone2)"
         @removeAsset="handleRemoveAsset(zone2)">
      </asset-zone>

      <!-- Away Logo -->
      <asset-zone 
         :zone="zone3"
         :currScene="currScene"
         :hidden="isHiddenZone(zone3)"
         :scale="scale"
         @click.native="handleZoneClicked(zone3)"
         @removeAsset="handleRemoveAsset(zone3)">
      </asset-zone>

      <!-- Home Text -->
      <text-zone 
         :zone="zone4"
         :currScene="currScene"
         :hidden="isHiddenZone(zone4)"
         :scale="scale"
         @click.native="handleZoneClicked(zone4)"
         @removeAsset="handleRemoveAsset(zone4)">
      </text-zone>

      <!-- Away TExt -->
      <text-zone 
         :zone="zone5"
         :currScene="currScene"
         :hidden="isHiddenZone(zone5)"
         :scale="scale"
         @click.native="handleZoneClicked(zone5)"
         @removeAsset="handleRemoveAsset(zone5)">
      </text-zone>

      <!-- Left Ad -->
      <asset-zone 
         :zone="zone6"
         :currScene="currScene"
         :hidden="isHiddenZone(zone6)"
         :scale="scale"
         @click.native="handleZoneClicked(zone6)"
         @removeAsset="handleRemoveAsset(zone6)">
      </asset-zone>

      <!-- Home BG Color -->
      <color-zone    
         :zone="zone7"
         :currScene="currScene"
         :hidden="isHiddenZone(zone7)"
         :scale="scale"
         @click.native="handleZoneClicked(zone7)"
         @removeAsset="handleRemoveAsset(zone7)">
      </color-zone>

      <!-- Away BG Color -->
      <color-zone 
         :zone="zone8"
         :currScene="currScene"
         :hidden="isHiddenZone(zone8)"
         :scale="scale"
         @click.native="handleZoneClicked(zone8)"
         @removeAsset="handleRemoveAsset(zone8)">
      </color-zone>

      <!-- Home Secondary Color -->
      <color-zone 
         :zone="zone9"
         :currScene="currScene"
         :hidden="isHiddenZone(zone9)"
         :scale="scale"
         @click.native="handleZoneClicked(zone9)"
         @removeAsset="handleRemoveAsset(zone9)">
      </color-zone>

      <!-- Away Secondary Color -->
      <color-zone 
         :zone="zone10"
         :currScene="currScene"
         :hidden="isHiddenZone(zone10)"
         :scale="scale"
         @click.native="handleZoneClicked(zone10)"
         @removeAsset="handleRemoveAsset(zone10)">
      </color-zone>

      <div id="channel-container">
         <div id="template-container" data-template="volleyball">

            <!-- Scene 1 = The FULL SCOREBOARD -->
            <div id="" class="full-scoreboard scene-01" :class="{active: currScene == 'scene1'}">
               <!-- Get the background image from BARD; default set in CSS -->
               <div class="score-inner-wrapper">

                  <div class="fairplay-branding">
                     <div class="logo">
                        <img src="./assets/fairplay-logo.png">
                     </div>
                  </div>

                  <div class="content-inner">
                     <div class="scoreboard-wrapper">
                        <div class="left">
                           <div class="left-top team-name home-team-text" :style="zone9.style">
                           </div>
                           <div class="left-middle score-wrapper">
                              <div class="score">
                                 <span id="" class="score-number">0</span>
                              </div>
                              <!-- Get the background color from BARD; default set in CSS  -->
                              <div id="" class="alpha" :style="zone7.style"></div>
                           </div>
                           <!-- Get the background color from BARD; default set in CSS  -->
                           <div id="" class="left-bottom challenge-tol-wrapper home-primary">
                              <div class="challenge">
                                 <div class="indicators">
                                    <span id="fp_home_challenge_3" class="circle"></span>
                                    <span id="fp_home_challenge_2" class="circle"></span>
                                    <span id="fp_home_challenge_1" class="circle"></span>
                                 </div>
                                 <div class="header"><span>Challenge</span></div>
                              </div>
                              <div class="tol">
                                 <div class="indicators">
                                    <!-- Add .used class to the span for timeouts used -->
                                    <!-- Right aligned for the home team -->
                                    <span id="fp_home_to_2" class="circle"></span>
                                    <span id="fp_home_to_1" class="circle"></span>
                                 </div>
                                 <div class="header"><span>TO</span></div>
                              </div>

                           </div>
                        </div>

                        <div class="center">
                           <div class="center-wrapper">
                              <div class="period set">
                                 <span class="header uppercase">Set&nbsp;</span>
                                 <span id="fp_set" class="number">1</span>
                              </div>
                              <div class="sets-won">
                                 <span class="header uppercase">Sets Won</span>
                                 <div class="scores">
                                    <span id="fp_home_sets_won" class="number">00</span>
                                    <span id="fp_vis_sets_won" class="number">00</span>
                                 </div>
                              </div>
                              <div class="possession">
                                 <div class="indicators">
                                    <div class="arrow-wrapper">
                                       <!-- Add active class to the svg to indicate possession -->
                                       <svg id="fp_pos_home" class="arrow active" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55.46 37.95">
                                          <g id="Layer_2" data-name="Layer 2">
                                             <g id="Layer_5" data-name="Layer 5">
                                                <polygon class="arrow-1" points="50.47 18.98 54.77 37.19 1.54 18.98 54.77 0.77 50.47 18.98"/>
                                             </g>
                                          </g>
                                          </svg>
                                    </div>
                                 </div>
                                 <div class="header uppercase"><span>Serve</span></div>
                                 <div class="indicators">
                                    <div class="arrow-wrapper">
                                       <!-- Add active class to the svg to indicate possession -->
                                       <svg id="fp_pos_vis" class="arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55.46 37.95">
                                          <g id="Layer_2" data-name="Layer 2">
                                             <g id="Layer_5" data-name="Layer 5">
                                                <polygon class="arrow-1" points="50.47 18.98 54.77 37.19 1.54 18.98 54.77 0.77 50.47 18.98"/>
                                             </g>
                                          </g>
                                       </svg>
                                 </div>
                                 </div>
                              </div>
                           </div>
                        </div>

                        <div class="right">
                           <div class="right-top team-name" :style="zone10.style">
                              
                           </div>
                           <div class="right-middle score-wrapper">
                              <div class="score">
                                 <span id="" class="score-number">0</span>
                              </div>
                              <!-- Get the background color from BARD; default set in CSS  -->
                              <div id="" class="alpha" :style="zone8.style"></div>
                           </div>
                           <!-- Get the background color from BARD; default set in CSS  -->
                           <div id="" class="right-bottom challenge-tol-wrapper away-primary">
                              <div class="challenge">
                                 <div class="header"><span>Challenge</span></div>
                                 <div class="indicators">
                                    <span id="fp_vis_challenge_1" class="circle"></span>
                                    <span id="fp_vis_challenge_2" class="circle"></span>
                                    <span id="fp_vis_challenge_3" class="circle"></span>
                                 </div>
                              </div>
                              <div class="tol">
                                 <div class="header"><span>TO</span></div>
                                 <div class="indicators">
                                    <!-- Add .used class to the span for timeouts used -->
                                    <!-- Left aligned for the visitor team -->
                                    <span id="fp_vis_to_1" class="circle"></span>
                                    <span id="fp_vis_to_2" class="circle"></span>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div><!-- END scoreboard-wrapper -->
                  </div>


                  <!-- If there are ads; there could be either just one, or two ads-->
                  <!-- <div class="ads-container">
                     <div class="ads-wrapper">
                        <div class="ad 1"></div>
                        <div class="ad 2"></div>
                     </div>
                  </div> -->
               </div>
            
            </div><!-- END .full-scoreboard -->

            <!-- Scene 2 = The MINI SCOREBOARD -->
            <!-- <div id="" class="mini-scoreboard scene-02" :class="{active: currScene == 'scene3'}">
               <div class="top">
                  <div class="bard-content"></div>
               </div>

               <div class="bottom">
                  <div class="scoreboard-wrapper">
                     <div class="left">
                        <div class="logo-wrapper">
                        </div>

                        <div class="name-bonus-wrapper">
                           <div class="left-top team-name" :style="zone9.style">
                           </div>
                           <div id="" class="left-bottom bonus-to-wrapper" :style="zone7.style">
                              <div class="vertical-centered">
                                 <div class="bonus">
                                    <div class="indicators">
                                       <div class="arrow-wrapper">
                                          <svg class="arrow 2 active" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55.46 37.95">
                                             <g id="Layer_2" data-name="Layer 2">
                                                <g id="Layer_5" data-name="Layer 5">
                                                   <polygon class="arrow-1" points="50.47 18.98 54.77 37.19 1.54 18.98 54.77 0.77 50.47 18.98"/>
                                                </g>
                                             </g>
                                          </svg>
                                       </div>
                                       <div class="arrow-wrapper">
                                          <svg class="arrow 1 active" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55.46 37.95">
                                             <g id="Layer_2" data-name="Layer 2">
                                                <g id="Layer_5" data-name="Layer 5">
                                                   <polygon class="arrow-1" points="50.47 18.98 54.77 37.19 1.54 18.98 54.77 0.77 50.47 18.98"/>
                                                </g>
                                             </g>
                                          </svg>
                                       </div>
                                    </div>
                                    <div class="header"><span>Bonus</span></div>
                                 </div>
                                 <div class="tol">
                                    <div class="indicators">
                                       <span id="5" class="circle used"></span>
                                       <span id="4" class="circle used"></span>
                                       <span id="3" class="circle used"></span>
                                       <span id="2" class="circle"></span>
                                       <span id="1" class="circle"></span>
                                    </div>
                                    <div class="header"><span>TO</span></div>
                                 </div>
                              </div>
                           </div>
                        </div>

                        <div class="score-wrapper">
                           <div class="score">
                              <div class="vertical-centered">
                                 <span id="" class="score-number">127</span>
                              </div>
                           </div>
                           <div id="" class="alpha" :style="zone7.style"></div>
                        </div>
                     </div>

                     <div class="center">
                        <div class="vertical-centered">  
                           <div class="game-clock"><span id="">08:06</span></div>
                           <div class="period">
                              <span id="" class="score-number">3rd</span>
                              <span class="header uppercase">&nbsp;Period</span></div>
                           <div class="possession">
                              <div class="indicators">
                                 <div class="arrow-wrapper">
                                    <svg class="arrow active" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55.46 37.95">
                                       <g id="Layer_2" data-name="Layer 2">
                                          <g id="Layer_5" data-name="Layer 5">
                                             <polygon class="arrow-1" points="50.47 18.98 54.77 37.19 1.54 18.98 54.77 0.77 50.47 18.98"/>
                                          </g>
                                       </g>
                                       </svg>
                                 </div>
                              </div>
                              <div class="header uppercase"><span>Poss</span></div>
                              <div class="indicators">
                                 <div class="arrow-wrapper">
                                    <svg class="arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55.46 37.95">
                                       <g id="Layer_2" data-name="Layer 2">
                                          <g id="Layer_5" data-name="Layer 5">
                                             <polygon class="arrow-1" points="50.47 18.98 54.77 37.19 1.54 18.98 54.77 0.77 50.47 18.98"/>
                                          </g>
                                       </g>
                                    </svg>
                              </div>
                              </div>
                           </div>
                        </div>
                     </div>

                     <div class="right">
                        <div class="score-wrapper">
                           <div class="score">
                              <div class="vertical-centered">
                                 <span id="" class="score-number">1</span>
                              </div>
                           </div>
                           <div id="" class="alpha" :style="zone8.style"></div>
                        </div>

                        <div class="name-bonus-wrapper">
                           <div class="right-top team-name" :style="zone10.style">
                           </div>

                           <div id="" class="right-bottom bonus-to-wrapper" :style="zone8.style">
                              <div class="vertical-centered">
                                 <div class="bonus">
                                    <div class="header"><span>Bonus</span></div>
                                    <div class="indicators">
                                       <div class="arrow-wrapper">
                                          <svg class="arrow 1 active" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55.46 37.95">
                                             <g id="Layer_2" data-name="Layer 2">
                                                <g id="Layer_5" data-name="Layer 5">
                                                   <polygon class="arrow-1" points="50.47 18.98 54.77 37.19 1.54 18.98 54.77 0.77 50.47 18.98"/>
                                                </g>
                                             </g>
                                          </svg>
                                       </div>
                                       <div class="arrow-wrapper">
                                          <svg class="arrow 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55.46 37.95">
                                             <g id="Layer_2" data-name="Layer 2">
                                                <g id="Layer_5" data-name="Layer 5">
                                                   <polygon class="arrow-1" points="50.47 18.98 54.77 37.19 1.54 18.98 54.77 0.77 50.47 18.98"/>
                                                </g>
                                             </g>
                                          </svg>
                                       </div>
                                    </div>
                                 </div>
                                 <div class="tol">
                                    <div class="header"><span>TO</span></div>
                                    <div class="indicators">
                                       <span id="1" class="circle"></span>
                                       <span id="2" class="circle"></span>
                                       <span id="3" class="circle"></span>
                                       <span id="4" class="circle used"></span>
                                       <span id="5" class="circle used"></span>
                                    </div>

                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="logo-wrapper">
                        </div>
                     </div>
                  </div>
                  
               </div>
               
            </div> -->


            <!-- Scene 3 = Scoreboard with Player Stats -->
             <!-- <div id="" class="player-stats scene-03" :class="{active: currScene == 'scene2'}"> 
                  <div class="bg-img-wrapper">
                     
                  </div>   
                  <div class="score-inner-wrapper">
                     
                   

                     <div class="content-inner">

                        <div class="scoreboard-wrapper">
                           <div class="left">
                              <div class="left-top team-name" :style="zone9.style">
                              </div>
                              <div class="left-middle score-wrapper">
                                 <div class="score">
                                    <span id="" class="score-number">0</span>
                                 </div>
                                 <div id="" class="alpha" :style="zone7.style"></div>
                              </div>
                              <div id="" class="left-bottom bonus-to-wrapper" :style="zone7.style">
                                 <div class="bonus">
                                    <div class="indicators">
                                       <div class="arrow-wrapper">
                                          <svg class="arrow 2 active" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55.46 37.95">
                                             <g id="Layer_2" data-name="Layer 2">
                                                <g id="Layer_5" data-name="Layer 5">
                                                   <polygon class="arrow-1" points="50.47 18.98 54.77 37.19 1.54 18.98 54.77 0.77 50.47 18.98"/>
                                                </g>
                                             </g>
                                          </svg>
                                       </div>
                                       <div class="arrow-wrapper">
                                          <svg class="arrow 1 active" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55.46 37.95">
                                             <g id="Layer_2" data-name="Layer 2">
                                                <g id="Layer_5" data-name="Layer 5">
                                                   <polygon class="arrow-1" points="50.47 18.98 54.77 37.19 1.54 18.98 54.77 0.77 50.47 18.98"/>
                                                </g>
                                             </g>
                                          </svg>
                                       </div>
                                    </div>
                                    <div class="header"><span>Bonus</span></div>
                                 </div>
                                 <div class="tol">
                                    <div class="indicators">
                                       <span id="5" class="circle used"></span>
                                       <span id="4" class="circle used"></span>
                                       <span id="3" class="circle used"></span>
                                       <span id="2" class="circle"></span>
                                       <span id="1" class="circle"></span>
                                    </div>
                                    <div class="header"><span>TO</span></div>
                                 </div>
                              </div>
                           </div>

                           <div class="center">
                              <div class="center-wrapper">
                                 <div class="center-top">
                                    <div class="game-clock"><span id="">08:00</span></div>
                                    <div class="period">
                                       <span id="" class="score-number">1st</span>
                                       <span class="header uppercase">&nbsp;Period</span></div>
                                    <div class="possession">
                                       <div class="indicators">
                                          <div class="arrow-wrapper">
                                             <svg class="arrow active" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55.46 37.95">
                                                <g id="Layer_2" data-name="Layer 2">
                                                   <g id="Layer_5" data-name="Layer 5">
                                                      <polygon class="arrow-1" points="50.47 18.98 54.77 37.19 1.54 18.98 54.77 0.77 50.47 18.98"/>
                                                   </g>
                                                </g>
                                                </svg>
                                          </div>
                                       </div>
                                       <div class="header uppercase"><span>Poss</span></div>
                                       <div class="indicators">
                                          <div class="arrow-wrapper">
                                             <svg class="arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55.46 37.95">
                                                <g id="Layer_2" data-name="Layer 2">
                                                   <g id="Layer_5" data-name="Layer 5">
                                                      <polygon class="arrow-1" points="50.47 18.98 54.77 37.19 1.54 18.98 54.77 0.77 50.47 18.98"/>
                                                   </g>
                                                </g>
                                             </svg>
                                       </div>
                                       </div>
                                    </div>
                                 </div>

                                 <div class="center-bottom">
                                    <div class="stats-wrapper">
                                       <div id="" class="table" :style="zone7.style">
                                          <div class="row header">
                                             <div class="cell"><span>#</span></div>
                                             <div class="cell"><span>PT</span></div>
                                             <div class="cell"><span>F</span></div>
                                          </div>
                                          <div class="row 1">
                                             <div class="cell"><span>01</span></div>
                                             <div class="cell"><span>21</span></div>
                                             <div class="cell"><span>1</span></div>
                                          </div>
                                          <div class="row 2">
                                             <div class="cell"><span>12</span></div>
                                             <div class="cell"><span>2</span></div>
                                             <div class="cell"><span>2</span></div>
                                          </div>
                                          <div class="row 3">
                                             <div class="cell"><span>15</span></div>
                                             <div class="cell"><span>5</span></div>
                                             <div class="cell"><span>3</span></div>
                                          </div>
                                          <div class="row 4">
                                             <div class="cell"><span>30</span></div>
                                             <div class="cell"><span>16</span></div>
                                             <div class="cell"><span>4</span></div>
                                          </div>
                                          <div class="row 5">
                                             <div class="cell"><span>34</span></div>
                                             <div class="cell"><span>10</span></div>
                                             <div class="cell"><span>4</span></div>
                                          </div>
                                       </div>
                                    </div>
                                    <div class="stats-wrapper">
                                       <div id="" class="table" :style="zone8.style">
                                          <div class="row header">
                                             <div class="cell"><span>#</span></div>
                                             <div class="cell"><span>PT</span></div>
                                             <div class="cell"><span>F</span></div>
                                          </div>
                                          <div class="row 1">
                                             <div class="cell"><span>01</span></div>
                                             <div class="cell"><span>21</span></div>
                                             <div class="cell"><span>1</span></div>
                                          </div>
                                          <div class="row 2">
                                             <div class="cell"><span>12</span></div>
                                             <div class="cell"><span>2</span></div>
                                             <div class="cell"><span>2</span></div>
                                          </div>
                                          <div class="row 3">
                                             <div class="cell"><span>15</span></div>
                                             <div class="cell"><span>5</span></div>
                                             <div class="cell"><span>3</span></div>
                                          </div>
                                          <div class="row 4">
                                             <div class="cell"><span>30</span></div>
                                             <div class="cell"><span>16</span></div>
                                             <div class="cell"><span>4</span></div>
                                          </div>
                                          <div class="row 5">
                                             <div class="cell"><span>34</span></div>
                                             <div class="cell"><span>10</span></div>
                                             <div class="cell"><span>4</span></div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>

                           <div class="right">
                              <div class="right-top team-name" :style="zone10.style">
                              </div>
                              <div class="right-middle score-wrapper">
                                 <div class="score">
                                    <span id="" class="score-number">1</span>
                                 </div>
                                 <div id="" class="alpha" :style="zone8.style"></div>
                              </div>
                              <div id="" class="right-bottom bonus-to-wrapper" :style="zone8.style">
                                 <div class="bonus">
                                    <div class="header"><span>Bonus</span></div>
                                    <div class="indicators">
                                       <div class="arrow-wrapper">
                                          <svg class="arrow 1 active" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55.46 37.95">
                                             <g id="Layer_2" data-name="Layer 2">
                                                <g id="Layer_5" data-name="Layer 5">
                                                   <polygon class="arrow-1" points="50.47 18.98 54.77 37.19 1.54 18.98 54.77 0.77 50.47 18.98"/>
                                                </g>
                                             </g>
                                          </svg>
                                       </div>
                                       <div class="arrow-wrapper">
                                          <svg class="arrow 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55.46 37.95">
                                             <g id="Layer_2" data-name="Layer 2">
                                                <g id="Layer_5" data-name="Layer 5">
                                                   <polygon class="arrow-1" points="50.47 18.98 54.77 37.19 1.54 18.98 54.77 0.77 50.47 18.98"/>
                                                </g>
                                             </g>
                                          </svg>
                                       </div>
                                    </div>
                                 </div>
                                 <div class="tol">
                                    <div class="header"><span>TO</span></div>
                                    <div class="indicators">
                                       <span id="1" class="circle"></span>
                                       <span id="2" class="circle"></span>
                                       <span id="3" class="circle"></span>
                                       <span id="4" class="circle used"></span>
                                       <span id="5" class="circle used"></span>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>

                     </div>
                  </div>
               
               </div> -->

         </div><!-- END #template-container -->
      </div><!-- END #channel-container -->
   </div>

   <!-- Scene Buttons -->
   <!-- <div class="scene-btns-wrapper" :style="templateWidth">
      <scene-button v-for="n in sceneCount"
         v-bind:key="n"
         v-bind:id="n"
         :isSelected="isScene(n)"
         v-on:sceneClicked="$emit('sceneClick', n)">
      </scene-button>
   </div> -->
</div>
</template>

<script>
import BaseTemplate from './../BaseTemplate';

export default {
   extends: BaseTemplate,

   data() {
      return {
         zone1: {},
         zone2: {},
         zone3: {},
         zone4: {},
         zone5: {},
         zone6: {},
         zone7: {},
         zone8: {},
         zone9: {},
         zone10: {},
      }
   },

   created() {
      this.assignZones();
   },

   methods: {

      assignZones() {
         
         this.zone1  = this.instanceJson.tmpl.assets[0];
         this.zone2  = this.instanceJson.tmpl.assets[1];
         this.zone3  = this.instanceJson.tmpl.assets[2];
 
         this.zone4  = this.instanceJson.tmpl.data.text[0];
         this.zone5  = this.instanceJson.tmpl.data.text[1];
 
         this.zone6  = this.instanceJson.tmpl.assets[3];
         this.zone7  = this.instanceJson.tmpl.assets[4];
         this.zone8  = this.instanceJson.tmpl.assets[5];
         this.zone9  = this.instanceJson.tmpl.assets[6];
         this.zone10 = this.instanceJson.tmpl.assets[7];
      },
   },

   watch: {
      instanceJson() {
         this.zones = this.instanceJson.tmpl.assets.concat(this.instanceJson.tmpl.data.text);
         this.assignZones();
      }
   },

   
}
</script>

<style lang="scss" scoped>
// This is a 16:9 resolution template, with pixel dimensions 1920x1080px 
$width: 1920px;
$height: 1080px;

// background colors 
$black: #000000; 
$white: #ffffff;
$home: #d2d2d3;
$away: #e2d6b5;
$darkgray:#5d5d5d;

@mixin team-name {
  text-transform: uppercase;
  font-family: 'Roboto Mono', sans-serif;
  font-size: 60px;
  font-weight: 700;
  line-height: 1;
  color: $black;
}
@mixin score {
  font-family: 'Roboto Mono', sans-serif;
  line-height: 1;
  letter-spacing: -0.05em;
  font-size: 310px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.05em;
  color: $white;
}
@mixin bonus {
  text-transform: uppercase;
  font-family: 'Roboto Mono', sans-serif;
  
  font-size: 56px;
  font-weight: 700;
  line-height: 1;
  color: $white;
}
@mixin game-clock {
  font-family: 'Roboto Mono', sans-serif;
  line-height: 1.2;
  letter-spacing: -1.2rem;
  font-size: 260px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.05em;
  color: $white;
}
@mixin period {
  font-family: 'Roboto Mono', sans-serif;
  line-height: 1.2;
  letter-spacing: -0.12rem;
  font-size: 96px;
  font-weight: 700;
  line-height: 1;
  color: $white;
}
@mixin possession {
  font-family: 'Roboto Mono', sans-serif;
  line-height: 1.2;
  letter-spacing: -0.12rem;
  font-size: 78px;
  font-weight: 700;
  line-height: 1;
  color: $white;
}
@mixin stats {
  font-family: 'Roboto Mono', sans-serif;
  font-size: 44px;
  font-weight: 700;
  line-height: 1;
  color: $white;
}

@mixin flex-centered {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-wrap: nowrap;
}

.vertical-centered {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
}

* {
  margin: 0;
  padding: 0;
  border: 0;
  box-sizing: border-box;
}

html {
  background-color: $black;
}

body {
  position: relative;
  width: $width;
  height: $height;
  background-color: $black;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  line-height: normal;
  color: $white;
  overflow: hidden;
}

.fairplay-branding {
   width: 100%;
  position: absolute;
  top: 30px;
  margin: 0 auto;
  text-align: center;
  z-index: 5000;
  pointer-events: none;
}

.uppercase {
  text-transform: uppercase;
}

.template-wrapper {
   width: 1920px;
   transform-origin: top left;
}

// The inline svg arrows for Bonus and Possession 
.arrow {
  display: inline-block; }
  .arrow .arrow-1 {
    fill: none;
    stroke: #fff;
    stroke-miterlimit: 10;
    opacity: 0.5; }
  .arrow.active .arrow-1 {
    fill: #fff;
    opacity: 1; }

.indicators .circle {
  display: inline-block;
  width: 35px;
  height: 35px;
  margin: 0 4px;
  background-color: #dee0e7;
  border: 1px solid #fff;
  border-radius: 50%;
  opacity: 1; }
  .indicators .circle.used {
    background-color: transparent;
    opacity: 0.5; }

.fairplay-branding {
  width: 100%;
  position: relative;
  top: 30px;
  margin: 0 auto;
  text-align: center; }

.ads-container {
  width: 100%;
  height: 176px;
  z-index: 2; }
  .ads-container .ads-wrapper {
    width: 100%;
    height: 100%;
    padding: 0 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: nowrap; }
  .ads-container .ad {
    flex: 0 0 930px;
    margin: 0 auto;
    background-color: transparent;
    overflow: hidden;
    position: relative;
    height: 182px;
    display: flex;
    justify-content: center; }
    .ads-container .ad img {
      position: absolute;
      max-width: 100%;
      height: 100%; }

#template-container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: transparent; }

.full-scoreboard {
  position: relative;
  width: 100%;
  height: 100%; }
  .full-scoreboard .bg-img {
    position: absolute;
    top: 0;
    left: 0;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    font-size: 0;
    z-index: 0; }
  .full-scoreboard .logos-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 340px;
    overflow: hidden;
    z-index: 1; }
    .full-scoreboard .logos-wrapper > div {
      width: 685px;
      height: 100%; }
      .full-scoreboard .logos-wrapper > div img {
        height: 340px;
        max-width: 100%; }
    .full-scoreboard .logos-wrapper .left {
      float: left;
      text-align: left; }
    .full-scoreboard .logos-wrapper .right {
      float: right;
      text-align: right; }
  .full-scoreboard .scoreboard-wrapper {
    top: 200px;
    left: 57px;
    width: 1806px;
    height: 702px;
    margin: 0 auto;
    padding: 55px 40px 0 40px;
    background-image: url("./assets/full-scoreboard-backplate.png");
    background-position: center top;
    background-size: 100%;
    background-repeat: no-repeat;
    z-index: 2; }
    .full-scoreboard .scoreboard-wrapper > div {
      display: inline-block;
      vertical-align: middle;
      height: 590px; }
    .full-scoreboard .scoreboard-wrapper .left, .full-scoreboard .scoreboard-wrapper .right {
      position: relative;
      width: 502px;
      padding: 8px;
      border-radius: 10px; }
      .full-scoreboard .scoreboard-wrapper .left::after, .full-scoreboard .scoreboard-wrapper .right::after {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: url("./assets/large-plate-border.png") center top no-repeat;
        background-size: auto;
        z-index: 1; }
      .full-scoreboard .scoreboard-wrapper .left > div, .full-scoreboard .scoreboard-wrapper .right > div {
        width: 488px;
        margin: 0 auto;
        overflow: hidden; }
        .full-scoreboard .scoreboard-wrapper .left > div > span, .full-scoreboard .scoreboard-wrapper .right > div > span {
          display: block;
          width: 100%; }
      .full-scoreboard .scoreboard-wrapper .left .team-name, .full-scoreboard .scoreboard-wrapper .right .team-name {
        height: 90px;
        background-color: #d2d2d3;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        text-align: center;
        flex-wrap: nowrap; }
        .full-scoreboard .scoreboard-wrapper .left .team-name span, .full-scoreboard .scoreboard-wrapper .right .team-name span {
          text-transform: uppercase;
          font-family: 'Roboto Condensed', sans-serif;
          font-size: 59px;
          font-weight: 700;
          line-height: 1;
          color: #000000;
          text-overflow: '';
          white-space: nowrap;
          overflow: hidden; }
      .full-scoreboard .scoreboard-wrapper .left .score-wrapper, .full-scoreboard .scoreboard-wrapper .right .score-wrapper {
        position: relative;
        height: 325px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        text-align: center;
        flex-wrap: nowrap; }
        .full-scoreboard .scoreboard-wrapper .left .score-wrapper > div, .full-scoreboard .scoreboard-wrapper .right .score-wrapper > div {
          position: absolute;
          top: 0;
          left: 0;
          display: block;
          height: 100%;
          width: 100%;
          flex: 1 0 100%; }
        .full-scoreboard .scoreboard-wrapper .left .score-wrapper .alpha, .full-scoreboard .scoreboard-wrapper .right .score-wrapper .alpha {
          z-index: 0;
          background-color: #5d5d5d;
          opacity: 0.35; }
        .full-scoreboard .scoreboard-wrapper .left .score-wrapper .score, .full-scoreboard .scoreboard-wrapper .right .score-wrapper .score {
          z-index: 1;
          text-indent: -31px; }
          .full-scoreboard .scoreboard-wrapper .left .score-wrapper .score span, .full-scoreboard .scoreboard-wrapper .right .score-wrapper .score span {
            font-family: 'Roboto Condensed', sans-serif;
            font-size: 310px;
            font-weight: 700;
            line-height: 1;
            letter-spacing: -0.05em;
            color: #ffffff; }
      .full-scoreboard .scoreboard-wrapper .left .challenge-tol-wrapper, .full-scoreboard .scoreboard-wrapper .right .challenge-tol-wrapper {
        height: 160px;
        padding: 20px;
        text-align: right;
        background-color: #5d5d5d; }
        .full-scoreboard .scoreboard-wrapper .left .challenge-tol-wrapper .challenge > div, .full-scoreboard .scoreboard-wrapper .left .challenge-tol-wrapper .tol > div, .full-scoreboard .scoreboard-wrapper .right .challenge-tol-wrapper .challenge > div, .full-scoreboard .scoreboard-wrapper .right .challenge-tol-wrapper .tol > div {
          display: inline-block; }
        .full-scoreboard .scoreboard-wrapper .left .challenge-tol-wrapper .header span, .full-scoreboard .scoreboard-wrapper .right .challenge-tol-wrapper .header span {
          text-transform: uppercase;
          font-family: 'Roboto Condensed', sans-serif;
          font-size: 56px;
          font-weight: 700;
          line-height: 1; }
    .full-scoreboard .scoreboard-wrapper .center {
      position: relative;
      width: 712px;
      margin: 0 auto;
      text-align: center; }
      .full-scoreboard .scoreboard-wrapper .center .center-wrapper {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0; }
      .full-scoreboard .scoreboard-wrapper .center .set span {
        font-family: 'Roboto Mono', sans-serif;
        font-size: 97px;
        font-weight: 700;
        line-height: 1.2;
        letter-spacing: -0.12rem;
        color: #ffffff; }
      .full-scoreboard .scoreboard-wrapper .center .sets-won {
        margin: 35px 0 50px 0; }
        .full-scoreboard .scoreboard-wrapper .center .sets-won .header {
          font-family: 'Roboto Mono', sans-serif;
          font-size: 72px;
          font-weight: 500;
          line-height: 1.2;
          letter-spacing: -0.12rem;
          color: #ffffff; }
        .full-scoreboard .scoreboard-wrapper .center .sets-won .scores {
          display: flex;
          justify-content: center;
          margin-top: -24px; }
          .full-scoreboard .scoreboard-wrapper .center .sets-won .scores span {
            flex: 0 0 50%;
            font-family: 'Roboto Mono', sans-serif;
            font-size: 208px;
            font-weight: 700;
            line-height: 1;
            letter-spacing: -0.12rem;
            color: #ffffff; }
      .full-scoreboard .scoreboard-wrapper .center .possession > div {
        display: inline-block;
        vertical-align: middle; }
      .full-scoreboard .scoreboard-wrapper .center .possession .header span {
        font-family: 'Roboto Mono', sans-serif;
        font-size: 78px;
        font-weight: 700;
        line-height: 1.2;
        letter-spacing: -0.12rem;
        color: #ffffff; }
      .full-scoreboard .scoreboard-wrapper .center .possession .indicators {
        width: 52px;
        height: 40px;
        margin: 0 30px; }
        .full-scoreboard .scoreboard-wrapper .center .possession .indicators:not(:first-of-type) {
          transform: rotate(180deg); }
        .full-scoreboard .scoreboard-wrapper .center .possession .indicators .arrow {
          width: 52px;
          height: 40px; }
  .full-scoreboard .ads-container {
    top: 900px; }

.score-inner-wrapper {
  height: 100%;
  position: relative; }

.content-inner {
  transform: translate(0%, -50%);
  top: 50%;
  position: absolute;
  width: 100%;
  z-index: 1001; }

.bg-img-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 0; }


</style>

